import {
    FETCH_COMBINED_PRACTITIONER_REQUEST,
    FETCH_COMBINED_PRACTITIONER_SUCCESS,
    FETCH_COMBINED_PRACTITIONER_FAILURE,
  } from "./FetchCombinedPractitionerListTypes";
  import api from "../../utils/Api";
  
  export const fetchCombinedPractitionerRequest = () => {
    return {
      type: FETCH_COMBINED_PRACTITIONER_REQUEST,
    };
  };
  
  export const fetchCombinedPractitionerSuccess = (practitioner) => {
    return {
      type: FETCH_COMBINED_PRACTITIONER_SUCCESS,
      payload: practitioner,
    };
  };
  
  export const fetchCombinedPractitionerFailure = (error) => {
    return {
      type: FETCH_COMBINED_PRACTITIONER_FAILURE,
      payload: error,
    };
  };
  
  export const fetchCombinedPractitioner = (practitioner_name, isCombinedPractitioner) => {
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    let url = "relatedparty/practitioner/autocomplete?practitioner_name="+practitioner_name;
    if(isCombinedPractitioner){
      url += "&isCombinePractitioner=" + isCombinedPractitioner ;
    }
    return async (dispatch) => {
      dispatch(fetchCombinedPractitionerRequest);
      try {
        const response = await api.get(url ,
          {
            headers: headers,
          }
        );
  
        const practitioner = response.data.data;
        //console.log("******* practitioner autocomplete - ", practitioner);
        dispatch(fetchCombinedPractitionerSuccess(practitioner));
      } catch (error) {
        console.log("Redux error - ", error.response);
        const errorMsg = error.message;
        dispatch(fetchCombinedPractitionerFailure(errorMsg));
      }
    };
  };
  